import { CancelButton } from '@core/components/Buttons';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import React, { useContext } from 'react';
import { FaArrowAltCircleUp } from 'react-icons/fa';
import { AcompanharReguaCobrancaContext } from '../../../AcompanharReguaCobrancaContext';
import { AcompanharReguaCobrancaModais } from '../AcompanharReguaCobrancaModais';
import DetalhesCobrancaForm from './DetalhesCobrancaForm';

const DetalhesCobrancaModal = () => {
  const [modalDetalhesCobranca, setModalDetalhesCobranca] = useContext(
    AcompanharReguaCobrancaContext
  ).modalDetalhesCobranca;

  const handleCloseModal = () => {
    setModalDetalhesCobranca('');
  };

  return (
    <SimpleDialog
      open={modalDetalhesCobranca === AcompanharReguaCobrancaModais.detalhesCobranca}
      onClose={handleCloseModal}
    >
      <SimpleDialogContent
        header={{
          title: 'Detalhe da cobrança',
          icon: <FaArrowAltCircleUp />,
          toolbar: (
            <>
              <CancelButton onClick={handleCloseModal}>Fechar</CancelButton>
            </>
          ),
        }}
        contentStyle={{ padding: 0 }}
        content={<DetalhesCobrancaForm />}
      />
    </SimpleDialog>
  );
};

export default DetalhesCobrancaModal;
